angular.module('gym.membership-plans').factory('MembershipPlanCategories', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('membership_plan_categories');
}]);
